import React from "react";
import { MenuItem, ListItemText, Typography, Box } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { Notification } from "./NotificationContext";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { formatDate, parseISTDate } from "Utils/Common";

dayjs.extend(relativeTime);

interface NotificationItemProps {
    notification: Notification;
    onClick: (notification: Notification) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onClick }) => {
    return (
        <MenuItem
            onClick={() => onClick(notification)}
            sx={{
                py: 1.5,
                backgroundColor: notification.title?.includes("SOS") ? "#fff5f5" : (notification.isRead ? "inherit" : "#f0f7ff"),
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "flex-start",
                gap: 1
            }}
        >
            {!notification.isRead && (
                <CircleIcon sx={{ fontSize: 10, color: "#1976d2", mt: 1 }} />
            )}
            <ListItemText
                primary={
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: notification.isRead ? 400 : 600,
                            wordBreak: "break-word",
                            whiteSpace: "normal"
                        }}
                    >
                        {notification.title}
                    </Typography>
                }
                secondary={
                    <Box component="span" sx={{ display: "block" }}>
                        <Typography
                            variant="body2"
                            color="text.primary"
                            sx={{
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                mb: 0.5
                            }}
                        >
                            {notification.message}
                        </Typography>
                        <Typography variant="caption" color="text.primary">
                            {parseISTDate(notification.createdAt).fromNow()}
                        </Typography>
                    </Box>
                }
            />
        </MenuItem>
    );
};

export default NotificationItem;
